function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.38087 9.15384C6.4481 9.12142 6.46565 9.03786 6.41593 8.98087C5.7066 8.16903 5.28764 7.11349 5.28764 5.99404C5.28764 4.17678 6.35943 2.61309 7.90865 1.8966C7.34354 1.05038 6.37891 0.5 5.28764 0.5C3.54353 0.5 2.11123 1.92509 2.11123 3.69421C2.11123 5.08001 2.98817 6.25054 4.20612 6.69283C1.95536 7.05647 0.259957 8.5789 0.279463 11.3407C0.942018 11.6355 2.02354 11.9205 3.68971 12.0296C4.19734 10.7568 5.12394 9.76911 6.38087 9.15384Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3432 6.6926C16.7453 6.18249 17.6836 4.70824 17.3659 3.05022C17.1331 1.82954 16.1568 0.826066 14.9505 0.572469C13.5845 0.28549 12.3217 0.876186 11.6406 1.89636C13.1801 2.60301 14.2519 4.17654 14.2519 5.9938C14.2519 7.11227 13.8329 8.16784 13.1314 8.97179C13.0817 9.02782 13.0992 9.11135 13.1665 9.14476C14.4234 9.76788 15.351 10.7566 15.8596 12.0294C17.5355 11.9203 18.617 11.6353 19.2796 11.3404C19.2893 8.57866 17.594 7.05624 15.3432 6.6926Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.0145 9.39437C12.3844 8.88034 13.3578 7.55255 13.3578 5.99671C13.3578 3.99469 11.7443 2.37695 9.75662 2.37695C7.76405 2.37695 6.15054 3.99469 6.15054 5.99671C6.15054 7.55255 7.12392 8.88034 8.49387 9.39437C5.95078 9.79242 4.05176 11.4593 4.05176 14.6594C4.05176 14.6594 6.60361 15.4997 9.75662 15.4997C12.9048 15.4997 15.4566 14.6594 15.4566 14.6594C15.4566 11.4593 13.5576 9.79242 11.0145 9.39437Z",
  fill: "currentColor"
});

var SvgTeam = function SvgTeam(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTeam, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/team.71442f32.svg";
export { ForwardRef as ReactComponent };